import { useComprehensiveTopNav, useCustomToast } from 'hooks';
import { routes } from 'lib/api';
import { Button, Typography } from 'lib/components';
import { TextField } from 'lib/components/FormFields';
import { RateType } from 'lib/util';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { actions, RequestManager, useAppDispatch, useSelectRequest } from 'store';
import classes from './index.module.scss';

const NUMBER_SYMBOL = ['$', '%'];

const AddCostAmplifierScreen = () => {
	const toast = useCustomToast();
	const { push, goBack } = useHistory();

	const dispatch = useAppDispatch();
	const { active } = useSelectRequest();

	const [name, setName] = useState('');
	const [affectCost, setAffectCost] = useState(false);
	const [regularRate, setRegularRate] = useState(0);
	const [overtimeRate, setOvertimeRate] = useState(0);
	const [weekendRate, setWeekendRate] = useState(0);
	const [holidayRate, setHolidayRate] = useState(0);
	const [regularRateTypeId, setRegularRateTypeId] = useState<RateType>(0);
	const [overtimeRateTypeId, setOvertimeRateTypeId] = useState<RateType>(0);
	const [weekendRateTypeId, setWeekendRateTypeId] = useState<RateType>(0);
	const [holidayRateTypeId, setHolidayRateTypeId] = useState<RateType>(0);

	useEffect(() => {
		const RM = new RequestManager(active);
		if (RM.idle()) return;

		if (RM.req(routes.CUSTOM_COST, 'POST')) {
			if (RM.failed()) {
				toast(active.message, 'error');
			} else if (RM.succeeded()) {
				toast(active.message);
				push('/settings/cost-amplifier');
			}
		}
	}, [active]);

	const handleSymbolChange = (field: 'regular' | 'overtime' | 'weekend' | 'holiday', symbol: RateType) => {
		if (field === 'regular') setRegularRateTypeId(symbol);
		else if (field === 'overtime') setOvertimeRateTypeId(symbol);
		else if (field === 'weekend') setWeekendRateTypeId(symbol);
		else setHolidayRateTypeId(symbol);
	};

	const handleCreate = () => {
		dispatch(
			actions.addCustomCost({
				name,
				affectCost,
				regularRate,
				overtimeRate,
				weekendRate,
				holidayRate,
				regularRateTypeId,
				overtimeRateTypeId,
				weekendRateTypeId,
				holidayRateTypeId,
			})
		);
	};

	useComprehensiveTopNav('Add New Custom Amplifier', { notificationVisible: true });

	return (
		<div className={classes['costAmplifier']}>
			<div className={classes['costAmplifier-form']}>
				<TextField
					placeholder="Does the patient have COVID-19?"
					label="Custom Field Title"
					variant="labelled"
					value={name}
					onChange={(e) => setName(e.target.value)}
				/>
				<div className={classes['costAmplifier-priceIncrease']}>
					<Typography color="darkgrey" variant="h6">
						If Yes Increase Price?:
					</Typography>
					<div className={classes['costAmplifier-priceIncrease-buttons']}>
						<Button
							title="Yes"
							variant="standard"
							color={affectCost ? 'primary' : 'gray'}
							onClick={() => setAffectCost(true)}
						/>
						<Button
							title="No"
							variant="standard"
							color={!affectCost ? 'primary' : 'gray'}
							sizing="small"
							onClick={() => setAffectCost(false)}
						/>
					</div>
				</div>
				<div className={classes['costAmplifier-hours']}>
					<Typography color="darkgrey" variant="h6">
						Increase Price by How Much?:
					</Typography>
					<div className={classes['costAmplifier-hours-fields']}>
						<TextField
							placeholder="7.50"
							label="Business Day (per hour)"
							type="number"
							variant="labelled"
							numberSymbol={NUMBER_SYMBOL}
							min={0}
							value={regularRate}
							onChange={(e) => setRegularRate(e.target.valueAsNumber)}
							defaultSymbolIndex={regularRateTypeId}
							onSymbolChange={(value) => handleSymbolChange('regular', value)}
						/>
						<TextField
							placeholder="7.50"
							label="Overtime (per hour)"
							type="number"
							variant="labelled"
							numberSymbol={NUMBER_SYMBOL}
							min={0}
							value={overtimeRate}
							onChange={(e) => setOvertimeRate(e.target.valueAsNumber)}
							defaultSymbolIndex={overtimeRateTypeId}
							onSymbolChange={(value) => handleSymbolChange('overtime', value)}
						/>
						<TextField
							placeholder="7.50"
							label="Weekend Day (per hour)"
							type="number"
							variant="labelled"
							numberSymbol={NUMBER_SYMBOL}
							min={0}
							value={weekendRate}
							defaultSymbolIndex={weekendRateTypeId}
							onChange={(e) => setWeekendRate(e.target.valueAsNumber)}
							onSymbolChange={(value) => handleSymbolChange('weekend', value)}
						/>
						<TextField
							placeholder="7.50"
							label="Holiday Day (per hour)"
							type="number"
							variant="labelled"
							numberSymbol={NUMBER_SYMBOL}
							min={0}
							value={holidayRate}
							defaultSymbolIndex={holidayRateTypeId}
							onChange={(e) => setHolidayRate(e.target.valueAsNumber)}
							onSymbolChange={(value) => handleSymbolChange('holiday', value)}
						/>
					</div>
				</div>
			</div>
			<div className={classes['costAmplifier-footerButtons']}>
				<Button title="Create New" variant="standard" color="primary" onClick={handleCreate} />
				<Button variant="standard" color="gray" title="Cancel" onClick={goBack} />
			</div>
		</div>
	);
};

export default AddCostAmplifierScreen;
